function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M10.13 18.5745C14.7922 18.5745 18.5717 14.7945 18.5717 10.1317C18.5717 5.46892 14.7922 1.68896 10.13 1.68896C5.46779 1.68896 1.68833 5.46892 1.68833 10.1317C1.68833 14.7945 5.46779 18.5745 10.13 18.5745Z",
  stroke: "#00D88A",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.1301 12.6643C11.5287 12.6643 12.6626 11.5303 12.6626 10.1315C12.6626 8.73262 11.5287 7.59863 10.1301 7.59863C8.73139 7.59863 7.59756 8.73262 7.59756 10.1315C7.59756 11.5303 8.73139 12.6643 10.1301 12.6643Z",
  stroke: "#00D88A",
  strokeWidth: 2.28335,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgDiscIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscIcon);
export default __webpack_public_path__ + "static/media/disc-icon.dbb7c10eb4963fa4b8b7f7184e453575.svg";
export { ForwardRef as ReactComponent };